import {React, classNames, observer} from '@api'
import { useStores } from '@modules'
import * as css from './NoProductsFound.css'

export const NoProductsFound = observer<{className?: any}>(function NoProductsFound({className}) {
  const {catalog: {settings: {activeSearchText}}, filter: {hasFilterTerms}} = useStores()
  console.log(activeSearchText)
  return <div className={classNames(css.root, className)}>
    {!activeSearchText && !hasFilterTerms ? activeSearchText === '' ? '' : `The library is empty.`
                                         : `Your query returned no results.  ${
        hasFilterTerms && activeSearchText ? `Try changing your filters or search.`
                                          : hasFilterTerms ? 'Try changing your filters.'
                                                                : 'Try changing your search.'}`}
  </div>
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/NoProductsFound.tsx